module.exports = __webpack_public_path__ + "img/bottom-bar-bg-2.ea552de5.png";